require('../../modules/es.object.keys');
var path = require('../../internals/path');

module.exports = path.Object.keys;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/object/keys.js
// module id = 396
// module chunks = 0 1